import MainAnalytics from './MainAnalytics';
import StepperAnalytics from './StepperAnalytics';

export default function ManageDynamicPageAnalytics() {
  return (
    <div className="flex flex-col py-6">
      <MainAnalytics />
      <StepperAnalytics />
    </div>
  );
}
